import { CORES_SITUACAO } from "../shared";

export default function Indicador({ titulo, valor, descricao, situacao }) {
    const cores = CORES_SITUACAO[situacao];

    return (
        <div style={{
            backgroundColor: cores.fundo,
            border: `1px solid ${cores.borda}`,
            borderRadius: 6,
            flex: '1 1 190px',
            minWidth: 190,
            padding: 16,
        }}>
            <div style={{ color: cores.texto, fontSize: 13, fontWeight: 700, textTransform: 'uppercase' }}>
                {titulo}
            </div>
            <div style={{ color: cores.texto, fontSize: 32, fontWeight: 700, lineHeight: 1.2 }}>
                {valor}
            </div>
            <div style={{ color: '#455a64', fontSize: 13 }}>{descricao}</div>
        </div>
    );
}
